import { observer } from "mobx-react";
import React from "react";
import "./FormInput.css";

type Props = {
	type: string;
	name: string;
	label?: string;
	required?: boolean;
	inputText: string;
	onChange: any;
	style?: any;
	labelStyle?: any;
};

type State = {
	isFocused: boolean;
};

@observer
class FormInputText extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isFocused: this.props.inputText.length > 0 ? true : false,
		};
		this.onInputChange = this.onInputChange.bind(this);
	}

	onInputChange = (e: any) => {
		const newValue = e.target.value;
		const newName = e.target.name;
		this.props.onChange(newValue, newName);
		// set child state here
	};

	onFocus = (e: any) => {
		this.setState({ isFocused: true });
	};

	onBlur = (e: any) => {
		if (this.props.inputText.length > 0) {
			this.setState({ isFocused: true });
		} else {
			this.setState({ isFocused: false });
		}
	};
	render() {
		return (
			<>
				<label style={this.props.labelStyle} className={`label ${this.state.isFocused ? "move-label" : ""}`}>{this.props.label}</label>
				{this.props.type !== "textarea" && (
					<input
						onChange={this.onInputChange}
						type={this.props.type}
						name={this.props.name}
						onFocus={this.onFocus}
						onBlur={this.onBlur}
						value={this.props.inputText}
						style={this.props.style}
						required={this.props.required ? this.props.required : false}
					/>
				)}

				{this.props.type === "textarea" && (
					<textarea
						onChange={this.onInputChange}
						name={this.props.name}
						onFocus={this.onFocus}
						onBlur={this.onBlur}
						value={this.props.inputText}
						style={this.props.style}
						required={this.props.required ? this.props.required : false}
						rows={7}
						cols={50}
					/>
				)}
			</>
		);
	}
}

export default FormInputText;
